'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirebaseProvider = exports.WithFirebaseApp = exports.defaultApplication = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.withFirebaseApp = withFirebaseApp;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _firebase = require('firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _lodash = require('lodash');

var _SubscriptionsController = require('./SubscriptionsController');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultApplication = exports.defaultApplication = {
  get app() {
    return _firebase2.default.app();
  },

  get auth() {
    return _firebase2.default.auth && _firebase2.default.auth();
  },

  get database() {
    return _firebase2.default.database && _firebase2.default.database();
  },

  get storage() {
    return _firebase2.default.storage && _firebase2.default.storage();
  },

  get controller() {
    this._controller = this._controller || new _SubscriptionsController.SubscriptionsController({
      app: _firebase2.default.app()
    });
    return this._controller;
  }

};
var FirebaseContext = React.createContext(defaultApplication);
var WithFirebaseApp = exports.WithFirebaseApp = FirebaseContext.Consumer;

var FirebaseProvider = exports.FirebaseProvider = function (_React$PureComponent) {
  _inherits(FirebaseProvider, _React$PureComponent);

  function FirebaseProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FirebaseProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirebaseProvider.__proto__ || Object.getPrototypeOf(FirebaseProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.initialState(), _this.subscriptionsController = new _SubscriptionsController.SubscriptionsController({
      app: _this.state.app,
      onLoad: _this.props.onLoad
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FirebaseProvider, [{
    key: 'initialState',
    value: function initialState() {
      console.log('Loading initial state');

      var app = this.props.app || this.props.config && _firebase2.default.initializeApp(this.props.config, (0, _v2.default)());

      if (!app) {
        throw new Error('No app or app config supplied to Firebase App Controller');
      }

      return {
        app: app
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.app !== this.props.app) {
        throw new Error('Firebase application changed mid-flight');
      }

      this.subscriptionsController.onLoad = this.props.onLoad;
    }
  }, {
    key: 'render',
    value: function render() {
      var app = this.state.app;
      var children = this.props.children;

      if (!app) {
        return null;
      }

      return React.createElement(FirebaseContext.Provider, {
        value: {
          app: app,
          database: app.database && app.database(),
          auth: app.auth && app.auth(),
          storage: app.storage && app.storage(),
          controller: this.subscriptionsController
        }
      }, children);
    }
  }]);

  return FirebaseProvider;
}(React.PureComponent);

function withFirebaseApp(Component) {
  return function (props) {
    return React.createElement(WithFirebaseApp, null, function (firebaseApp) {
      return React.createElement(Component, _extends({}, props, {
        firebaseApp: firebaseApp
      }));
    });
  };
}